import type { Mission } from '../missions.ts'

export const fhfa: Mission = {
  id: "fhfa",
  name: "Federal Housing Finance Agency",
  short: "FHFA",
  call: "Housing Finance",
  kind: "independent",
  community: "financial",
  url: "https://www.fhfa.gov/",
  established: 2008,
  palette: {
    primary: "#233e99",
    secondary: "#231f20",
    accent: "#c41130",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Housing_Finance_Agency.svg",
  },
  motif: "house",
  mission: {
    text: "The FHFA's mission is to ensure that Fannie Mae, Freddie Mac and the FHLBanks fulfill their mission by operating in a safe and sound manner to serve as a reliable source of liquidity and funding for housing finance and community investment.",
    url: "https://www.fhfa.gov/about",
  },
  fact: {
    text: "Since 2008, FHFA has served as conservator of Fannie Mae and Freddie Mac.",
    url: "https://www.fhfa.gov/about",
  },
  seal: {
    file: "public/seals/fhfa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Housing_Finance_Agency.svg",
  },
  identifier: {
    about: "https://www.fhfa.gov/about",
    accessibility: "https://www.fhfa.gov/about/fhfa-policies/accessibility",
    foia: "https://www.fhfa.gov/about/foia-privacy",
    noFear: "https://www.fhfa.gov/about/fhfa-policies/equal-employment-opportunity-no-fear-act",
    oig: "https://www.fhfaoig.gov/",
    performance: "https://www.fhfa.gov/about/budget-finances-and-performance",
    privacy: "https://www.fhfa.gov/about/fhfa-policies/website-privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fhfa-constitution-center.jpg",
        small: "/media/fhfa-constitution-center-sm.jpg",
        alt: "Constitution Center, a glass and stone office building that fills a city block in southwest Washington, D.C.",
        title: "Constitution Center, Washington, D.C.",
        creator: "ajay_suresh",
        source: "https://commons.wikimedia.org/wiki/File:Constitution_Center_-_Washington_DC_(53840482180).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
